import React from 'react';
import {
  CardActions,
  CardTitle,
  Button,
  Link,
  Typography
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useQuoteContext } from '../../../hooks/useQuoteContext';
import fallbackViewTexts from '../../../constants/fallbackViewTexts';

const NullViewContent = ({ carousel }) => {
  const { isMobile } = useQuoteContext();

  const {
    cardTitle,
    bodyText,
    learnMoreText
  } = fallbackViewTexts;

  return (
    <div
      data-testid="null-view-content"
      className={classNames(
        'sui-flex sui-flex-col sui-grow sui-justify-between',
        {
          'sui-ml-4 sui-p-2 sui-max-w-96 sui-gap-2 sui-h-full': carousel && !isMobile,
          'sui-max-w-lg sui-gap-4': !carousel && !isMobile,
          'sui-w-full sui-gap-2': isMobile
        }
      )}
    >
      <div
        className="sui-flex sui-flex-col sui-justify-between sui-h-full"
      >
        <div
          className="sui-flex sui-flex-col sui-gap-2 @sm:sui-gap-1 sui-h-full sui-pb-6"
        >
          <CardTitle
            headerVariant="h3"
            headerWeight="display"
            header={<span style={{ whiteSpace: 'pre-line' }}>{cardTitle}</span>}
          />
          <Typography>
            {bodyText}
          </Typography>
        </div>
        <CardActions>
          {
            // Carousel
            carousel && (
              <Link href="/c/create-a-quote">
                {learnMoreText}
              </Link>
            )
          }
          {
            // Mobile, non-carousel
            !carousel && isMobile && (
              <Button
                variant="secondary"
                fullWidth
                href="/c/create-a-quote"
              >
                {learnMoreText}
              </Button>
            )
          }
          {
            // Desktop, non-carousel
            !carousel && !isMobile && (
              <div className="sui-flex sui-flex-row sui-w-full">
                <div className="sui-w-full sui-grow @4xl:sui-hidden">
                  <Button
                    variant="secondary"
                    fullWidth
                    href="/c/create-a-quote"
                  >
                    {learnMoreText}
                  </Button>
                </div>
                <div className="sui-hidden @4xl:sui-flex">
                  <Button
                    variant="secondary"
                    fullWidth={false}
                    href="/c/create-a-quote"
                  >
                    {learnMoreText}
                  </Button>
                </div>
              </div>
            )
          }
        </CardActions>
      </div>
    </div>
  );
};

NullViewContent.propTypes = {
  carousel: PropTypes.bool
};

NullViewContent.defaultProps = {
  carousel: false
};

export default NullViewContent;
